import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "src/environments/environment";

// The translation files are served from a fixed path with a max-age, so without a per-deploy
// query string a fresh bundle can run against the previous deploy's keys. CI stamps `release`
// with the pipeline id and commit on every deploy.
export const createTranslateLoader = (http: HttpClient): TranslateHttpLoader =>
  new TranslateHttpLoader(http, "./assets/i18n/", `.json?v=${encodeURIComponent(environment.release)}`);
